<template>
  <div class="container coupon-container">
    <div class="header">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>运营管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/coupon/list' }">优惠券管理</el-breadcrumb-item>
        <el-breadcrumb-item>优惠券创建</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
        </div>
        <div class="right">
          <el-button
            plain
            @click="handleClose"
          >取消</el-button>
          <el-button
            type="primary"
            @click="handleSubmit"
          >保存</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <h3 class="title">优惠券创建</h3>
      <div class="content">
        <el-form
          class="dataForm"
          :model="dataForm"
          :rules="rules"
          ref="dataForm"
          label-width="110px"
        >
          <el-form-item
            label="类型"
            prop="min_cost"
          > <el-radio-group
              v-model="dataForm.type"
              @change="radioChange"
            >
              <el-radio
                class="input-radio"
                :label="1"
              >
                优惠券
              </el-radio>
              <el-radio
                class="input-radio"
                :label="2"
              >
                查看券
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="优惠券名称"
            prop="name"
          >
            <el-input
              v-model="dataForm.name"
              placeholder="请输入优惠券标题"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="优惠券简介"
            prop="description"
          >
            <el-input
              v-model="dataForm.description"
              placeholder="请输入优惠券简介，可用于描述使用规则"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="发放总量"
            prop="circulation"
            v-if="dataForm.type==1"
          >
            <el-input
              v-model="dataForm.circulation"
              placeholder="请输入发放总量"
            >
              <template slot="append">张</template>
            </el-input>
          </el-form-item>
          <el-form-item
            label="发放次数"
            prop="circulation"
            v-if="dataForm.type==2"
          >
            <el-input
              v-model="dataForm.circulation"
              placeholder="请输入发放次数"
            >
              <template slot="append">次</template>
            </el-input>
          </el-form-item>
          <el-form-item
            label="单次领取量"
            prop="discount_download_count"
            v-if="dataForm.type==2"
          >
            <el-input
              v-model="dataForm.discount_download_count"
              placeholder="请输入单次领取量"
            >
              <template slot="append">张</template>
            </el-input>
          </el-form-item>
          <el-form-item
            label="使用门槛"
            prop="min_cost"
            v-if="dataForm.type==1"
          >
            <el-radio
              class="input-radio"
              v-model="min_cost_radio"
              :label="1"
            >
              <span class="text">无门槛</span>
            </el-radio>
            <el-radio
              class="input-radio"
              v-model="min_cost_radio"
              :label="2"
            >
              <span class="text">订单满</span>
              <el-input
                v-model="dataForm.min_cost"
                :disabled="min_cost_radio != 2"
                style=" margin: 0 5px;"
              ><template slot="append">元</template></el-input>
            </el-radio>
          </el-form-item>
          <el-form-item
            label="优惠内容"
            prop="discount_amount"
            v-if="dataForm.type==1"
          >
            <el-radio
              class="input-radio"
              v-model="discount_radio"
              :label="1"
            >
              <span class="text">减免</span>
              <el-input
                v-model="dataForm.discount_amount"
                :disabled="discount_radio != 1"
                style=" margin: 0 5px;"
              ><template slot="append">元</template></el-input>
            </el-radio>
            <el-radio
              class="input-radio"
              v-model="discount_radio"
              :label="2"
            >
              <span class="text">打折</span>
              <el-input
                v-model="dataForm.discount_rate"
                :disabled="discount_radio != 2"
                style=" margin: 0 5px;"
              ><template slot="append">折</template></el-input>
            </el-radio>
          </el-form-item>
          <el-form-item
            label="适用商品"
            prop="ref_goods"
            v-if="dataForm.type==1"
          >
            <el-radio
              class="input-radio"
              v-model="ref_goods_radio"
              :label="1"
            >全部商品可用</el-radio>
            <div class="goods-wrap">
              <el-radio
                class="input-radio"
                v-model="ref_goods_radio"
                :label="2"
              >指定商品可用</el-radio>
              <div
                class="content-list"
                v-if="ref_goods_radio == 2"
              >
                <div
                  class="list-item"
                  v-for="(item, index) of goods"
                  :key="index"
                >
                  <span class="name">{{item.name}}</span>
                  <span class="btn">
                    <i
                      class="el-icon-close"
                      @click="handleGoodsRemove(item)"
                    ></i>
                  </span>
                </div>
                <el-button
                  type="text"
                  @click="goodsChooseDialog = true"
                >选择商品</el-button>
              </div>
            </div>
            <div class="group-wrap">
              <el-radio
                class="input-radio"
                v-model="ref_goods_radio"
                :label="3"
              >指定商品组可用</el-radio>
              <div
                class="content-list"
                v-if="ref_goods_radio == 3"
              >
                <div
                  class="list-item"
                  v-for="(item, index) of groups"
                  :key="index"
                >
                  <span class="name">{{item.name}}</span>
                  <span class="btn">
                    <i
                      class="el-icon-close"
                      @click="handleGroupRemove(item)"
                    ></i>
                  </span>
                </div>
                <el-button
                  type="text"
                  @click="categoryChooseDialog = true"
                >选择商品组</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            label="推广状态"
            prop="promote_status"
            v-if="computePermission('Coupon:EditPromoteStatus')"
          >
            <el-radio-group
              v-model="dataForm.promote_status"
              class="radio-group"
            >
              <el-radio :label="0">仅后台查看发放</el-radio>
              <el-radio :label="1">普通详情页可见</el-radio>
              <el-radio :label="2">推广详情页可见</el-radio>
              <el-radio :label="3">全部详情页可见</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="用券时间"
            prop="datetime"
          >
            <el-date-picker
              class="datetime"
              v-model="dataForm.datetime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="max-width: 400px;"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="排序值"
            prop="sort"
          >
            <el-input
              v-model="dataForm.sort"
              placeholder="请输入排序值，纯数字"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="在线状态"
            prop="status"
          >
            <el-switch v-model="dataForm.status"></el-switch>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <GoodsTabsChoose
      :visible="goodsChooseDialog"
      :goods="goods"
      @close="goodsChooseDialog = false"
      @submit="saveGoods"
    />
    <CategoryChoose
      :visible="categoryChooseDialog"
      :groups="groups"
      @close="categoryChooseDialog = false"
      @submit="saveGroups"
    />
  </div>
</template>

<script>
import GoodsTabsChoose from '@/components/dialog/product/GoodsTabsChoose'
import CategoryChoose from '@/components/dialog/product/CategoryChoose'
import { couponCreate } from '@/api/operation'
import { computePermission } from '@/utils/helper'


export default {
  components: {
    GoodsTabsChoose,
    CategoryChoose
  },
  watch: {
    // 时间数据监听
    'dataForm.datetime': {
      handler(value) {
        if (value) {
          this.dataForm.start_time = this.$moment(value[0]).valueOf()
          this.dataForm.end_time = this.$moment(value[1]).valueOf()
        } else {
          this.dataForm.start_time = null
          this.dataForm.end_time = null
        }
      }
    }
  },
  created() {
    this.dataForm.promote_status = 0
  },
  data() {
    return {
      goodsChooseDialog: false,
      categoryChooseDialog: false,
      dataForm: {
        name: '研盒优惠券',
        description: '仅限当日有效',
        circulation: 1,
        sort: 1,
        status: true,
        start_time: Number(this.$moment().startOf('day').format('x')),
        end_time: Number(this.$moment().endOf('day').format('x')),
        datetime: [Number(this.$moment().startOf('day').format('x')), Number(this.$moment().endOf('day').format('x'))],
        type: 1,
      },
      ref_goods_radio: 1,
      discount_radio: 1,
      min_cost_radio: 1,
      goods: [],
      groups: [],
      types: [
        { label: '课程优惠券', value: 1 },
        { label: '题库优惠券', value: 2 },
        { label: '阅读资料优惠券', value: 3 },
        { label: '实体资料优惠券', value: 4 },
      ],
      rules: {
        name: [{ required: true, message: '请输入优惠券名称', trigger: 'blur' }],
        description: [{ required: true, message: '请输入优惠券简介', trigger: 'blur' }],
        circulation: [{ required: true, message: '请输入发放总量', trigger: 'blur' }],
        discount_download_count: [{ required: true, message: '请输入单次领取量', trigger: 'blur' }],
        min_cost: [
          {
            required: true, message: '请设置使用门槛', trigger: 'change', validator: (rule, value, callback) => {
              if (this.min_cost_radio == 2 && !this.dataForm.min_cost) {
                return callback(new Error(rule.message))
              } else {
                callback()
              }
            }
          }
        ],
        discount_amount: [
          {
            required: true, message: '请设置优惠内容', trigger: 'change', validator: (rule, value, callback) => {
              if (this.discount_radio == 1 && !this.dataForm.discount_amount) {
                return callback(new Error(rule.message))
              } else if (this.discount_radio == 2 && !this.dataForm.discount_rate) {
                return callback(new Error(rule.message))
              } else {
                callback()
              }
            }
          }
        ],
        ref_goods: [
          {
            required: true, message: '请设置适用商品', trigger: 'change', validator: (rule, value, callback) => {
              if (this.ref_goods_radio == 2 && !this.goods.length) {
                return callback(new Error(rule.message))
              } else if (this.ref_goods_radio == 3 && !this.groups.length) {
                return callback(new Error(rule.message))
              } else {
                callback()
              }
            }
          }
        ],
        datetime: [{ required: true, message: '请设置用券时间', trigger: 'change' }],
        sort: [{ required: true, message: '请输入排序值，纯数字', trigger: 'blur' }],
        status: [{ required: false, message: '请设置上线状态', trigger: 'change' }],
        promote_status: [{ required: true, message: '请选择推广状态', trigger: 'change' }],
      },
      computePermission: computePermission
    }
  },
  methods: {
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (this.dataForm.type == 1) {
            var params = {
              name: this.dataForm.name,
              description: this.dataForm.description || '',
              circulation: this.dataForm.circulation,
              min_cost: this.dataForm.min_cost,
              discount_rate: this.dataForm.discount_rate,
              discount_amount: this.dataForm.discount_amount,
              start_time: this.dataForm.start_time,
              end_time: this.dataForm.end_time,
              sort: this.dataForm.sort,
              status: this.dataForm.status ? 1 : 0,
              promote_status: this.dataForm.promote_status,
            }
            // 适用商品处理
            if (this.ref_goods_radio == 1) {
              params.ref_ids = null
              params.ref_group_ids = null
            } else if (this.ref_goods_radio == 2) {
              params.ref_ids = this.goods.map(v => v.id).join(',')
              params.ref_group_ids = null
            } else if (this.ref_goods_radio == 3) {
              params.ref_ids = null
              params.ref_group_ids = this.groups.map(v => v.id).join(',')
            }
            // 使用门槛处理
            if (this.min_cost_radio == 1) {
              params.min_cost = null
            }
            // 优惠内容处理
            if (this.discount_radio == 1) {
              params.discount_rate = null
            } else if (this.discount_radio == 2) {
              params.discount_amount = null
            }
          } else if (this.dataForm.type == 2) {
            var params = {
              name: this.dataForm.name,
              description: this.dataForm.description || '',
              discount_download_count: this.dataForm.discount_download_count,
              circulation: this.dataForm.circulation,
              discount_amount: null,
              discount_rate: null,
              start_time: this.dataForm.start_time,
              end_time: this.dataForm.end_time,
              sort: this.dataForm.sort,
              status: this.dataForm.status ? 1 : 0,
              promote_status: this.dataForm.promote_status,
              ref_ids: '-1',
              ref_group_ids: null,
            }
          }

          couponCreate(params).then(res => {
            this.$message.success(`创建成功`)
            this.$refs['dataForm'].resetFields()
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    saveGoods({ goods }) {
      this.goods = goods
    },
    handleGoodsRemove(item) {
      this.goods = this.goods.filter(v => v.id !== item.id)
    },
    saveGroups({ groups }) {
      this.groups = groups
    },
    handleGroupRemove(item) {
      this.groups = this.groups.filter(v => v.id !== item.id)
    },
    handleClose() {
      this.$router.go(-1)
    },
    radioChange(e) {
      if (e == 1) {
        this.dataForm.name = '研盒优惠券'
      } else if (e == 2) {
        this.dataForm.name = '研盒查看券'

      }
    }
  }
}
</script>

<style scoped lang="less">
.coupon-container {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .main {
    background: #fff;
    padding: 20px;
    margin-top: 10px;

    .title {
      font-size: 32px;
      font-weight: bold;
    }
  }
  .content {
    display: flex;
    margin-top: 20px;

    .dataForm {
      min-width: 700px;

      .input-radio {
        display: flex;
        align-items: center;
        height: 32px;

        & + .input-radio {
          margin-top: 10px;
        }

        .text {
          width: 60px;
        }
      }

      /deep/ .el-radio__label {
        display: flex;
        align-items: center;
      }
      /deep/ .el-input {
        max-width: 400px;
      }
      .radio-group {
        display: flex;
        /deep/.el-radio {
          display: flex;
          margin-top: 8px;
        }
      }
    }

    .goods-wrap,
    .group-wrap {
      display: flex;
      margin-top: 10px;

      .input-radio {
        width: 110px;
      }

      .content-list {
        flex: 1;
        background: #f5f5f5;
        padding: 0 15px;
      }
      .list-item {
        display: flex;
        justify-content: space-between;

        &:hover {
          color: #333;
        }

        .btn {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
